import React from "react";
import { useAds } from "../hooks/AdsContext";
import AIAdvisorCard from "./Step3_Targeting/AIAdvisorCard";
import AudienceProfile from "./Step3_Targeting/AudienceProfile";
import ContextHintsInput from "./Step3_Targeting/ContextHintsInput";
import GeolocationCenter from "./Step3_Targeting/GeolocationCenter";
import InvestmentConfig from "./Step3_Targeting/InvestmentConfig";
import PredictedResultsCard from "./Step3_Targeting/PredictedResultsCard";

const Step3_Targeting: React.FC = () => {
  const { platform, loadLinkedinAccounts } = useAds();

  // Contas de anúncio LinkedIn só são usadas neste step (AudienceProfile).
  // Carrega sob demanda ao entrar aqui com a plataforma certa; o próprio
  // `loadLinkedinAccounts` ignora chamadas repetidas para o mesmo contexto,
  // então voltar/avançar entre steps não gera requests duplicados.
  // `useLayoutEffect` (não `useEffect`) para setar `loadingLinkedinAccounts`
  // antes do browser pintar o primeiro frame — evita um flash do aviso
  // "Nenhuma conta encontrada" em AudienceProfile antes do fetch começar.
  React.useLayoutEffect(() => {
    if (platform === "linkedin") void loadLinkedinAccounts();
  }, [platform, loadLinkedinAccounts]);

  // ChatGPT Ads segmenta por CONTEXTO de conversa (context_hints), não por
  // demografia/interesses/geolocalização — não faz sentido mostrar
  // AudienceProfile/GeolocationCenter/AIAdvisorCard nesse fluxo.
  if (platform === "chatgpt_ads") {
    return (
      <div className="w-full animate-in fade-in slide-in-from-bottom-3 duration-400 space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-4 items-stretch">
          <div className="xl:col-span-7 flex flex-col">
            <ContextHintsInput />
          </div>
          <div className="xl:col-span-5 flex flex-col">
            <InvestmentConfig />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full animate-in fade-in slide-in-from-bottom-3 duration-400 space-y-4">
      {/* Full-width compact row: AI Advisor / Predicted Results */}
      {platform === "linkedin" ? <PredictedResultsCard /> : <AIAdvisorCard />}

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-4 items-stretch">
        {/* Left Column (7/12): Audience */}
        <div className="xl:col-span-7 flex flex-col">
          <AudienceProfile />
        </div>

        {/* Right Column (5/12): Investment */}
        <div className="xl:col-span-5 flex flex-col">
          <InvestmentConfig />
        </div>
      </div>

      {/* Full-width row: Geolocation & Radius */}
      <GeolocationCenter />
    </div>
  );
};

export default Step3_Targeting;
